<!-- <mat-progress-spinner diameter=100 mode="indeterminate" color="primary"></mat-progress-spinner> -->
<img src="../../assets/img/dark-loader.gif" alt="" class="loader">
<div class="loading">{{text}}...</div>